import { UserRole } from 'src/api/Api';
import { Role, NavItem, NavConfig } from './nav.types';

// This function merges menus from multiple roles and de-duplicates them.
export const getNavItemsForRoles = (userRoles: UserRole[] | null | undefined, navConfig: NavConfig): NavItem[] => {
  if (!userRoles || userRoles.length === 0) {
    return [];
  }

  const roles = userRoles.map((role) => role.toString().toUpperCase() as Role);
  const hasUserRole = roles.includes('USER');
  const hasAdminRole = roles.includes('ADMIN');
  const hasEmployeeRole = roles.includes('EMPLOYEE');

  const userItems = navConfig.USER || [];
  const adminItems = navConfig.ADMIN || [];
  const employeeItems = navConfig.EMPLOYEE || [];

  const finalItems: NavItem[] = [];
  const addedPaths = new Set<string>();

  const addItems = (items: NavItem[]) => {
    items.forEach((item) => {
      if (item.path && !addedPaths.has(item.path)) {
        finalItems.push(item);
        addedPaths.add(item.path);
      } else if (!item.path) {
        finalItems.push(item);
      }
    });
  };

  if (hasUserRole) {
    addItems(userItems);
  }

  if (hasUserRole && (hasAdminRole || hasEmployeeRole)) {
    finalItems.push({ divider: true });
  }

  if (hasAdminRole) {
    addItems(adminItems);
  }

  if (hasEmployeeRole) {
    addItems(employeeItems);
  }

  return finalItems;
};
